import { Col, Row } from 'antd';
import qs from 'qs';

function EmailVerificationRequestContainer() {
  const { email } = qs.parse(window.location.search, {
    ignoreQueryPrefix: true,
  });
  return (
    <div>
      <Row justify="center" style={{ marginTop: '100px' }}>
        <Col>
          <h2>회원가입(사용자 등록)을 완료 하였습니다.</h2>
        </Col>
      </Row>
      <Row justify="center">
        <Col>
          <h2>{email} 메일함을 확인하여 이메일 인증을 해 주세요.</h2>
        </Col>
      </Row>
    </div>
  );
}

export default EmailVerificationRequestContainer;
